function DonutChart({ data, size = 220, strokeWidth = 24, gap = 16 }) {
  const cx = size / 2;
  const cy = size / 2;
  const r = cx - strokeWidth / 2 - 6;
  const circumference = 2 * Math.PI * r;

  const total = data.reduce((sum, d) => sum + d.value, 0);
  const totalGapLength = gap * data.length;
  const available = circumference - totalGapLength;

  if (!total) return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      <circle cx={cx} cy={cy} r={r} fill="none" stroke="var(--color-border-primary)" strokeWidth={strokeWidth} />
    </svg>
  );

  let cumulative = 0;

  return (
    <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
      {data.map((d, i) => {
        const arcLength = (d.value / total) * available;
        const dashArray = `${arcLength} ${circumference - arcLength}`;
        const dashOffset = -cumulative;
        cumulative += arcLength + gap;

        return (
          <circle
            key={i}
            cx={cx}
            cy={cy}
            r={r}
            fill="none"
            stroke={d.color}
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={dashArray}
            strokeDashoffset={dashOffset}
            transform={`rotate(-90, ${cx}, ${cy})`}
          />
        );
      })}
    </svg>
  );
}

export default DonutChart;
